module.exports = __webpack_public_path__ + "img/1516052538.b30bd1c2.jpg";